import React from "react";
import { useTracking } from "react-tracking";



export const useSortEvents = (props) => {

  const { trackEvent } = useTracking();

  return () => {
    if (props.action.type === "call") {
      trackEvent({
        funComponent: "card",
        numberCalled: `${props.url}`,
        placeCalled: `${props.description}`,
        event: "CallButton-Clicked",
      });
    }else if (props.action.type === "mail"){
        trackEvent({
          funComponent: "card",
          mailAdress: `${props.url}`,
          emailDescription: `${props.description}`,
          event: "CallButton-Clicked",
        });
    }
  };
};
